import React from "react";
import { ConfigForm_SectionWrapper } from "../../WidgetMetricCard/ConfigForm/ConfigForm_SectionWrapper";
import { WidgetHeader } from "../../WidgetBarChart/WIDGET_ELEM_ConfigForm";
import { PieChartConfigProvider, usePieChartConfig } from "./ConfigForm_Context";
import { ConfigForm_TypeSection } from "./ConfigForm_TypeSection";
import { ConfigForm_Dimension1Section, Dimension1AddFieldButton } from "./ConfigForm_Dimension1Section";
import { ConfigForm_ConfigureSection } from "./ConfigForm_ConfigureSection";
import { ConfigForm_DisplaySection } from "./ConfigForm_DisplaySection";
import { MultiLayerSection, MultiLayerAddButton } from "./ConfigForm_MultiLayerSection";
import { ConfigForm_FiltersSection } from "./ConfigForm_FiltersSection";
import { useWidgetFilterControls } from "../../utils/useWidgetFilterControls";
import { getWidgetHasDimensions } from "../../utils/getWidgetContentTypes";
import { CollapseTransition } from "../../utils/CollapseTransition";

const PieChartConfigFormInner = ({ widgetIcon, widgetTitle, filterHeaderProps, filterControlProps }) => {
  const { pieChartType } = usePieChartConfig();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.4rem' }}>
      <WidgetHeader title={widgetTitle} type="Chart" icon={widgetIcon} />

      <ConfigForm_TypeSection />

      {/* Single Layer mode */}
      <CollapseTransition isVisible={pieChartType === 'singleLayer'}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.4rem' }}>
          <ConfigForm_SectionWrapper icon="ChartDonut" title="Data" headerRight={<Dimension1AddFieldButton />}>
            <ConfigForm_Dimension1Section />
          </ConfigForm_SectionWrapper>

          <ConfigForm_ConfigureSection />
        </div>
      </CollapseTransition>

      {/* Multi Layer (Sunburst) mode */}
      <CollapseTransition isVisible={pieChartType === 'multiLayer'}>
        <ConfigForm_SectionWrapper icon="CirclesThree" title="Data Layers" headerRight={<MultiLayerAddButton />}>
          <MultiLayerSection />
        </ConfigForm_SectionWrapper>
      </CollapseTransition>

      {/* Display — always visible */}
      <ConfigForm_DisplaySection />

      {/* Filters — always visible */}
      <ConfigForm_SectionWrapper
        icon="Funnel"
        title="Filters"
        {...filterHeaderProps}
      >
        <ConfigForm_FiltersSection {...filterControlProps} />
      </ConfigForm_SectionWrapper>
    </div>
  );
};

export const PieChartConfigForm = ({
  thisWidgetConfig,
  setConfig,
  underEditWidgetIdx,
  showNumberInputsInOptions,
  dimensionsInputPropsConfig,
  widgetIcon,
  widgetTitle,
}) => {
  const widgetType = thisWidgetConfig?.comp || 'WidgetPieChart';
  const hasDimensions = getWidgetHasDimensions(thisWidgetConfig, widgetType);
  const { filterHeaderProps, filterControlProps } = useWidgetFilterControls({ hasDimensions });

  return (
    <PieChartConfigProvider
      thisWidgetConfig={thisWidgetConfig}
      setConfig={setConfig}
      underEditWidgetIdx={underEditWidgetIdx}
      showNumberInputsInOptions={showNumberInputsInOptions}
      dimensionsInputPropsConfig={dimensionsInputPropsConfig}
    >
      <PieChartConfigFormInner
        widgetIcon={widgetIcon}
        widgetTitle={widgetTitle}
        filterHeaderProps={filterHeaderProps}
        filterControlProps={filterControlProps}
      />
    </PieChartConfigProvider>
  );
};
